// src/App.tsx
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import AppBar from './components/AppBar';
import Footer from './components/Footer';

import HomePage from './pages/HomePage';
import FoodPage from './pages/FoodPage';
import SearchPage from './pages/SearchPage';
import RestaurantMenuPage from './pages/RestaurantMenuPage';
import BestillPage from './pages/BestillPage';
import DriversPage from './pages/DriversPage';
import CreditsPage from './pages/CreditsPage';
import AboutPage from './pages/AboutPage';
import VisionOverlay from './pages/VisionOverlay';
import AdminPage from './pages/AdminPage';
import DriverPortalPage from './pages/DriverPortalPage';
import RestaurantPortalPage from './pages/RestaurantPortalPage';
import AdminHubPage from './pages/AdminHubPage';
import Terms from './pages/Terms'; 
import KokkPage from "./pages/KokkPage"; 


/** Ruller til toppen ved route-bytte, fordi folk liker å lese ting fra start. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors flex flex-col pb-20">
        <AppBar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/food" element={<FoodPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/restaurant/:restaurantId" element={<RestaurantMenuPage />} />
            <Route path="/bestill" element={<BestillPage />} />
            <Route path="/drivers" element={<DriversPage />} />
            <Route path="/credits" element={<CreditsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/driverportal" element={<DriverPortalPage />} />
            <Route path="/restaurantportal" element={<RestaurantPortalPage />} />
            <Route path="/adminhub" element={<AdminHubPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/vision" element={<VisionOverlay />} />
            <Route path="/blikokk" element={<KokkPage />} />
            {/* Ny rute for salgsvilkår */}
            <Route path="/salgsvilkar" element={<Terms />} />

            {/* 404, fordi folk alltid skriver feil url */}
            <Route
              path="*"
              element={
                <div className="max-w-3xl mx-auto px-4 py-16 text-center">
                  <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-3">
                    404
                  </h1>
                  <p className="text-gray-600 dark:text-gray-400 mb-6">
                    Siden finnes ikke. Gå hjem og lat som ingenting.
                  </p>
                  <a
                    href="/"
                    className="inline-block px-6 py-3 rounded-lg bg-[#004D99] hover:bg-[#003366] text-white font-semibold"
                  >
                    Til forsiden
                  </a>
                </div>
              }
            />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
